import { MeshLayout, Mesh } from "./Mesh";
import { VertexBuffer } from "../Object/VertexBuffer";
import { ITexture } from "../Texture";
import { Collection } from "@spi/Common/Geometry";
import { RenderObject } from "../Object/RenderObject";

export class GeometryMesh extends Mesh {
    public buffer: VertexBuffer;
    public texture: ITexture;
    public dataLayout: MeshLayout;

    public bufferGeneratedMesh(geoCollection: Collection, compilationPattern = 'pnc') {

        let gl = this.ctx.gl;
        geoCollection.setCompilationOptions({
            compilationPattern: compilationPattern
        })
        let compiled = geoCollection.compile(true);

        this.dataLayout = {
            position: { offset: 0, length: 3 },
            normal: { offset: 3, length: 3 },
            diffuseTexture: { offset: 6, length: 2 },
            color: { offset: 6, length: 4 }
        };

        let glVertexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, glVertexBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, compiled.geometryData, gl.STATIC_DRAW);

        this.buffer = new VertexBuffer(glVertexBuffer, gl.TRIANGLES, compiled.vertexLength, compiled.vertexCount);


        this.texture = null;
    }

    public createInstance(): RenderObject {
        return new RenderObject(this);
    }

}